import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function getDefaultVon(rotationsplan: Rotationsplan): Date {
  const alleStationen = rotationsplan.getAllStationen();
  if (alleStationen.length > 0) {
    const letzteStation = alleStationen[alleStationen.length - 1];
    return dayjs(letzteStation.bis).add(1, 'day').toDate();
  }

  return new Date();
}
